import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/scss';

export default function (element, data) {
    const swiperContainer = element.querySelector('.letters-swiper');
    const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    const nextBtn = element.querySelector(".swiper-button-next");
    const prevBtn = element.querySelector(".swiper-button-prev");

    const swiperOptions = {
        modules: [Autoplay, Navigation],
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 10,
        centerInsufficientSlides: true,
        speed: data.transition ? data.transition : 900,
        loop: true,
        autoplay: data.timeout ? {delay: data.timeout} : false,
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
    };

    // Клонируем слайды, пока общая ширина меньше, чем ширина экрана * 2
    const screenWidth = window.innerWidth;
    if (getSlidesWidth() > screenWidth) {
        while (getSlidesWidth() < screenWidth * 2) {
            slides.forEach(slide => {
                const cloneSlide = slide.cloneNode(true);
                swiperWrapper.appendChild(cloneSlide);
            });
        }

        nextBtn.style.display = 'block';
        prevBtn.style.display = 'block';
    } else if (nextBtn && prevBtn) {
        nextBtn.style.display = 'none';
        prevBtn.style.display = 'none';
    }
    
    element.swiper = new Swiper(swiperContainer, swiperOptions);

    function getSlidesWidth() {
        return Array.from(swiperWrapper.children).reduce((totalWidth, slide) => {
            return totalWidth + slide.offsetWidth;
        }, 0);
    }
};